import { render } from "./assignTestModal.vue?vue&type=template&id=2103170a&scoped=true"
import script from "./assignTestModal.js?vue&type=script&lang=js"
export * from "./assignTestModal.js?vue&type=script&lang=js"

import "./assignTestModal.vue?vue&type=style&index=0&id=2103170a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2103170a"]])

export default __exports__